export default "__VITE_ASSET__CKUARZN9__"